/* ==========================================================
   Gieleh Theme — theme.js
   Landing-page behaviour on Shopify: cart drawer (AJAX Cart API),
   quick-add, mobile menu, reveals, toast · PDP gallery · variants
   ========================================================== */
(function () {
  'use strict';
  var CFG = window.GIELEH || { assets: {}, routes: {} };
  var R = CFG.routes;
  var cartJs = R.cartJs || '/cart.js', cartAdd = (R.cartAdd || '/cart/add') + '.js', cartChange = (R.cartChange || '/cart/change') + '.js';

  function formatMoney(cents) {
    var f = CFG.moneyFormat || '€{{amount}}';
    var amount = cents / 100;
    var s = f.indexOf('amount_no_decimals') > -1 ? Math.round(amount).toString()
          : f.indexOf('amount_with_comma_separator') > -1 ? amount.toFixed(2).replace('.', ',')
          : amount.toFixed(2);
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, s).replace(/<[^>]+>/g, '');
  }
  function esc(str) { return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;'); }

  /* ── Drawer ─────────────────────────────────────────────── */
  var drawer = document.getElementById('cartDrawer'), scrim = document.getElementById('scrim');
  function openDrawer() { drawer && drawer.classList.add('open'); scrim && scrim.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { drawer && drawer.classList.remove('open'); scrim && scrim.classList.remove('open'); document.body.style.overflow = ''; }

  /* ── Mobile menu ────────────────────────────────────────── */
  var menu = document.getElementById('mobileMenu');
  function openMenu() { menu && menu.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeMenu() { menu && menu.classList.remove('open'); document.body.style.overflow = ''; }

  /* ── Toast ──────────────────────────────────────────────── */
  var toastTimer;
  function toast(msg) {
    var t = document.getElementById('toast');
    if (!t) { t = document.createElement('div'); t.id = 'toast'; t.className = 'toast'; t.setAttribute('role', 'status'); t.setAttribute('aria-live', 'polite'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('show');
    clearTimeout(toastTimer); toastTimer = setTimeout(function () { t.classList.remove('show'); }, 2200);
  }

  /* ── Render cart ────────────────────────────────────────── */
  var lastCart = null;
  function render(cart) {
    lastCart = cart;
    var n = cart.item_count || 0;
    document.querySelectorAll('.cart-count').forEach(function (el) { el.textContent = n; el.classList.toggle('show', n > 0); });
    document.querySelectorAll('.drawer-count').forEach(function (el) { el.textContent = n + (n === 1 ? ' piece' : ' pieces'); });
    var body = document.getElementById('drawerBody'), foot = document.getElementById('drawerFoot');
    if (!body) return;
    if (!n) {
      body.innerHTML = '<div class="drawer-empty"><img src="' + esc(CFG.assets.sealInk) + '" alt=""><p>Your bag is empty.</p><a class="btn btn-ghost-gold" href="' + esc(R.all || '/collections/all') + '">Explore the collection</a></div>';
      if (foot) foot.style.display = 'none';
      return;
    }
    if (foot) foot.style.display = 'block';
    body.innerHTML = cart.items.map(function (i) {
      var meta = (i.vendor || '') + (i.variant_title && i.variant_title !== 'Default Title' ? ' · ' + i.variant_title : '');
      var img = i.image ? '<img class="ph-img" src="' + esc(i.image.replace(/(\.[a-z]+)(\?|$)/, '_300x$1$2')) + '" alt="">' : '<img class="ph-seal" src="' + esc(CFG.assets.sealInk) + '" alt="" style="width:42%">';
      return '<div class="cart-item"><div class="ci-media ph">' + img + '</div>' +
        '<div class="ci-info"><a class="ci-name" href="' + esc(i.url) + '">' + esc(i.product_title) + '</a><span class="ci-material">' + esc(meta) + '</span>' +
        '<div class="ci-qty"><button type="button" data-dec="' + esc(i.key) + '" aria-label="Decrease">–</button><span>' + i.quantity + '</span><button type="button" data-inc="' + esc(i.key) + '" aria-label="Increase">+</button></div></div>' +
        '<div class="ci-right"><span class="ci-price">' + formatMoney(i.final_line_price) + '</span><button class="ci-remove" type="button" data-rm="' + esc(i.key) + '">Remove</button></div></div>';
    }).join('');
    var sub = document.getElementById('drawerSubtotal');
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }

  /* ── Cart API ───────────────────────────────────────────── */
  var H = { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  function fetchCart() { return fetch(cartJs).then(function (r) { return r.json(); }); }
  function refresh() { return fetchCart().then(render); }
  function change(key, qty) { return fetch(cartChange, { method: 'POST', headers: H, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); }).then(render); }
  function add(variantId, qty) {
    return fetch(cartAdd, { method: 'POST', headers: H, body: JSON.stringify({ id: parseInt(variantId, 10), quantity: qty || 1 }) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { toast(res.description || 'This piece could not be added.'); return; }
        return refresh().then(function () { toast('Added to bag'); openDrawer(); });
      });
  }
  function qtyOf(key) { var it = lastCart && lastCart.items.find(function (x) { return x.key === key; }); return it ? it.quantity : 0; }

  /* ── Events ─────────────────────────────────────────────── */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action],[data-variant-id],[data-inc],[data-dec],[data-rm]');
    if (!t) return;
    var a = t.dataset.action;
    if (a === 'open-cart') { e.preventDefault(); refresh().then(openDrawer); }
    else if (a === 'close-cart') closeDrawer();
    else if (a === 'open-menu') openMenu();
    else if (a === 'close-menu') closeMenu();
    else if (t.dataset.variantId) { e.preventDefault(); e.stopPropagation(); t.disabled = true; t.textContent = 'Adding…'; add(t.dataset.variantId).then(function () { t.disabled = false; t.textContent = t.dataset.label || 'Add to bag'; }); }
    else if (t.dataset.inc) change(t.dataset.inc, qtyOf(t.dataset.inc) + 1);
    else if (t.dataset.dec) change(t.dataset.dec, qtyOf(t.dataset.dec) - 1);
    else if (t.dataset.rm) change(t.dataset.rm, 0);
  });
  scrim && scrim.addEventListener('click', closeDrawer);
  menu && menu.addEventListener('click', function (e) { if (e.target.tagName === 'A') closeMenu(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); closeMenu(); } });

  /* PDP add-to-bag forms */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-cart-form]');
    if (!form) return;
    e.preventDefault();
    var id = form.querySelector('[name="id"]'), q = form.querySelector('[name="quantity"]'), btn = form.querySelector('[data-add-btn]');
    if (!id) return;
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    add(id.value, q ? parseInt(q.value, 10) || 1 : 1).then(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to bag'; } });
  });

  /* Touch: first tap on a tile reveals alt photo + quick-add; second tap follows the link */
  if (window.matchMedia('(hover: none)').matches) {
    document.addEventListener('click', function (e) {
      var card = e.target.closest('.product-card');
      if (!card || e.target.closest('.quick-add')) return;
      if (!card.classList.contains('touched')) {
        e.preventDefault();
        document.querySelectorAll('.product-card.touched').forEach(function (c) { c.classList.remove('touched'); });
        card.classList.add('touched');
      }
    });
  }

  /* Reveal on scroll */
  function initReveal() {
    var els = document.querySelectorAll('.reveal:not(.in)');
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); } });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }
  initReveal();
  document.addEventListener('shopify:section:load', initReveal);

  window.GielehCart = { open: openDrawer, close: closeDrawer, addToCart: add, toast: toast };
  fetchCart().then(render).catch(function () {});

  /* ============================================================
     5. ACCORDION
     ============================================================ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.gl-acc__btn');
    if (!btn) return;
    var item = btn.closest('.gl-acc__item');
    if (!item) return;
    item.dataset.open = item.dataset.open === 'true' ? 'false' : 'true';
  });

  /* ============================================================
     6. PDP GALLERY — thumbnail swap
     ============================================================ */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-pdp-thumb]');
    if (!thumb) return;
    var mainImg = document.getElementById('gl-pdp-main');
    if (mainImg) {
      mainImg.src = thumb.dataset.pdpThumb;
      mainImg.srcset = '';
    }
    document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
      t.setAttribute('aria-current', String(t === thumb));
    });
  });

  /* ============================================================
     7. PDP VARIANT SELECTOR
     ============================================================ */
  var variantData = [];
  document.querySelectorAll('[data-variant-json]').forEach(function (el) {
    try { variantData.push(JSON.parse(el.textContent)); } catch (e) {}
  });

  function getSelectedVariant() {
    var selects = document.querySelectorAll('[data-variant-select]');
    if (!selects.length) return variantData[0];
    var selectedOptions = Array.from(selects).map(function (s) { return s.value; });
    return variantData.find(function (v) {
      return v.options && selectedOptions.every(function (opt, i) { return v.options[i] === opt; });
    }) || variantData[0];
  }

  document.addEventListener('change', function (e) {
    if (!e.target.closest('[data-variant-select]')) return;
    var variant = getSelectedVariant();
    if (!variant) return;

    var priceEl  = document.getElementById('gl-pdp-price');
    var addBtn   = document.querySelector('[data-add-btn]');
    var varInput = document.getElementById('gl-variant-id');

    if (varInput)  varInput.value = variant.id;
    if (priceEl)   priceEl.innerHTML = '<span class="gl-price"><span class="gl-price__now">' + variant.price + '</span></span>';
    if (addBtn) {
      addBtn.disabled = !variant.available;
      if (variant.available) {
        addBtn.dataset.label = 'Add to bag \u2014 ' + variant.price;
        addBtn.textContent   = 'Add to bag \u2014 ' + variant.price;
      } else {
        addBtn.textContent = 'Sold out';
      }
    }
  });

  /* ============================================================
     8. UTILITIES
     ============================================================ */
  function escapeHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

})();
